import { string } from '@amcharts/amcharts4/core';
import { Component, OnInit, Input } from '@angular/core';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';

@Component({
  standalone: false,
  selector: 'nexus-form-result',
  templateUrl: './nexus-form-result.component.html',
  styleUrls: ['./nexus-form-result.component.scss']
})
export class NexusFormResultComponent implements OnInit {
  @Input() public model: NexusFormResultModel;
  @Input() public addClass: string = "";

  constructor() { }

  ngOnInit() {
  }

}
